/**
 * @flow
 * @format
 */

import _StepGroup from './StepGroup';

export default _StepGroup;



// WEBPACK FOOTER //
// ./src/components/StepGroup/index.js